module.exports = __webpack_public_path__ + "static/media/about-image-first.1a920fb6.png";